import { PLAYER_STATUS_CATEGORIES, PLAYER_STATUS } from './constants';
import './PlayerApi';
import PlayerStore from './PlayerStore';

import Request from '@hotmart/request';

export default class PlayerService {
  static fetchThumbnail(mediaCode) {
    return Request('media.fetch.thumbnail', { mediaCode });
  }

  static async setSupportedLangs() {
    if (!PlayerStore.supportedLangs.length) {
      PlayerStore.supportedLangs = await Request('media.supported_langs');
    }
  }

  static fetchReport(mediaCode) {
    return Request('media.fetch.report', { mediaCode });
  }

  static generateSignature(mediaCode) {
    return Request('media.signature', { mediaCode });
  }

  static getStatusCategory(status) {
    let categoryStatus = PLAYER_STATUS.NONE;
    const categories = Object.keys(PLAYER_STATUS_CATEGORIES);

    categories.forEach((cat) => {
      const categoryStatusList = PLAYER_STATUS_CATEGORIES[cat];

      categoryStatus = categoryStatusList.includes(status)
        ? cat
        : categoryStatus;
    });

    return categoryStatus;
  }

  static getMediaInfo(mediaCode) {
    return Request('media.info', { mediaCode });
  }

  static uploadThumbnail(id, thumbnail) {
    return Request('media.register.thumbnail', { id, thumbnail });
  }

  static updateOriginalLanguage(mediaCode, language) {
    return Request('media.update.language', { mediaCode, language });
  }

  static fetchMediaUrl(mediaCode) {
    return Request('media.mediaUrl', { mediaCode });
  }
}
